export default "__VITE_ASSET__CdAbbMRz__"